export enum DocumentStatusEnum {
    isNew = 'NEW',
    Saved = 'SAVED',
    Received = 'RECEIVED',    // Технич.
    Verified = 'VERIFIED',
    InProcess = 'INPROCESS',
    PreApproved = 'PREAPPROVED',
    Approved = 'APPROVED',
    Execution = 'READY_FOR_EXECUTION',
    OnExecution = 'ONEXECUTION',
    Executed = 'EXECUTED',
    Declined = 'DECLINED',
    Postponed = 'POSTPONED',
    Virtual = 'VIRTUAL'
}

export enum PublicDocumentStatusEnum {
    Inprocess = 'inprocess',
    Declined = 'declined',
    Executed = 'executed',
}

export const historyDocumentPdfAvailable = (historyDocument: any) => {
    return true;
    // (historyDocument.state === PublicDocumentStatusEnum.Executed)
    //     || (historyDocument.state === PublicDocumentStatusEnum.Declined);
}

export const historyDocumentPdfUrl = (documentId: Number, download = false, locale = 'en') => {
    const pdflocale = locale === 'ru' ? 'ru' : 'en';
    return `/webapi/finance/pdf/document?id=${documentId}&${download ? 'download=1' : ''}&pdflocale=${pdflocale}`;
}

